import styled from 'styled-components';

// PM Analitik Faz 2 Plan 4 (spec §7) — Süreç Takibi yerleşimi. Tek kaydırma: üst kısım (yol, süzgeç şeridi, sekmeler) sabit;
// Özet sekmesinde sekme içeriği kaydırılır, Görevler sekmesinde yalnız DataTable satırları (SurveyDetailPage deseni:
// height:100% + min-height:0 + ölçülen tablo yüksekliği).
export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
`;

export const Header = styled.div`
  flex-shrink: 0;
`;

export const TabContent = styled.div`
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: ${({ $scroll }) => ($scroll ? 'auto' : 'hidden')};
`;

export const PageEmpty = styled.div`
  padding: 40px 0;
  text-align: center;
  color: ${({ theme }) => theme.colors.text.muted};
  font-size: ${({ theme }) => theme.metrics.font.size.md};
`;

export const KpiSelect = styled.div`
  width: 150px;
  max-width: 100%;
`;

export const CellLink = styled.button`
  all: unset;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.primary.main};
  font-weight: ${({ theme }) => theme.metrics.font.weight.semiBold};

  &:hover { text-decoration: underline; }
  &:focus-visible { outline: 2px solid ${({ theme }) => theme.colors.primary.main}; outline-offset: 2px; }
`;

export const Dash = styled.span`
  color: ${({ theme }) => theme.colors.text.muted};
`;

export const ExpandRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 8px;
`;

export const AiGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;

  @media (max-width: 1024px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const AiCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 14px;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.bgColor};
  min-width: 0;
`;

export const AiTitle = styled.div`
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
  font-weight: ${({ theme }) => theme.metrics.font.weight.bold};
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const AiBody = styled.div`
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  color: ${({ theme }) => theme.colors.text.primary};
  line-height: 1.4;
`;

export const AiMeta = styled.div`
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  color: ${({ theme }) => theme.colors.text.muted};
`;

export const AiActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 8px;
  margin-top: auto;
`;
